module.exports = __webpack_public_path__ + "static/Biopartner-b0bc0ea77f9392a1e7da60a9ba5a1d0c.jpg";